{each, extend, find, map, omit} = require 'underscore'

mergeRedemptionLocationInfo = (optionIdMap, redemptionLocationMap) ->
  return {} unless optionIdMap

  for id, shippingOption of optionIdMap
    optionWithRedemptionLocation = find shippingOption, (option) ->
      option.redemptionLocations?.length
    each optionWithRedemptionLocation?.redemptionLocations, (location) ->
      extend location, omit(redemptionLocationMap[location.id], 'id', 'uuid')

  optionIdMap

getBuyUrlWithShippingOptionData = (buyUrl, shippingOptionData) ->
  params = []

  for key, value of shippingOptionData
    params.push("#{key}=#{value}") if value

  "#{buyUrl}#{if buyUrl.indexOf('?') > -1 then '&' else '?'}#{params.join '&'}"

getRedemptionLocationsFromResponse = (response={}, variantId) ->
  {optionIdMap, redemptionLocationMap} = response
  return [] unless optionIdMap and redemptionLocationMap

  shippingOptions = optionIdMap[variantId]

  optionWithRedemptionLocation = find shippingOptions, (option) ->
    option.redemptionLocations?.length

  return [] unless optionWithRedemptionLocation?.redemptionLocations?.length

  map optionWithRedemptionLocation.redemptionLocations, (location) ->
    extend {}, location, omit(redemptionLocationMap[location.id], 'id', 'uuid')

getFormattedTodayHours = (openHours) ->
  return unless openHours
  txnPath = "js.modules.goods_local_supply_v2"
  msg = ""
  todayHours = find openHours, (obj) -> (obj.dayOfWeek % 7) is (new Date()).getDay()
  if todayHours?.openNow
    msg = "#{I18n.t(txnPath+'.open_today')} #{todayHours.displayTime}"
  else
    msg = I18n.t(txnPath+'.closed_today')

  msg

module.exports = {mergeRedemptionLocationInfo, getBuyUrlWithShippingOptionData, getRedemptionLocationsFromResponse, getFormattedTodayHours}
